/**
 * Shared CTA shape for the claim card (SFRA `.btn` inside `.c-loyalty-form`):
 * full width, 8px radius, 16px Grotesque at the Medium cut, ~14px vertical
 * padding. Applied on top of the Button `cta` / `secondary` variants, which
 * supply the per-theme colours.
 */
export const claimCtaClassName =
  "w-full rounded-[8px] px-9 py-3.5 text-base font-medium leading-normal";
